import { AlertTriangle, RefreshCw, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useWhatsAppHealth } from '../hooks/useWhatsAppHealth';

/**
 * Waarschuwingsbanner die verschijnt zodra de laatste WhatsApp-verzending
 * faalde door een verlopen/ongeldig Meta access token. De fout wordt door de
 * `send-whatsapp` edge function weggeschreven naar `whatsapp_settings` en na
 * een geslaagde verzending automatisch weer gewist.
 *
 * Alleen zichtbaar voor beheerders, omdat alleen zij het token kunnen
 * vernieuwen in Instellingen -> WhatsApp.
 */
export default function WhatsAppHealthAlert() {
  const { profile } = useAuth();
  const navigate = useNavigate();
  const isAdmin = profile?.role === 'Admin';
  const { health, refetch, isFetching } = useWhatsAppHealth(isAdmin);

  if (!isAdmin || !health?.tokenError) {
    return null;
  }

  const when = health.tokenErrorAt
    ? new Date(health.tokenErrorAt).toLocaleString('nl-NL', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="bg-red-600 text-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <AlertTriangle className="h-4 w-4 flex-shrink-0" />
            <p className="text-sm font-medium truncate">
              WhatsApp-koppeling probleem: token verlopen of ongeldig — berichten worden niet
              verzonden.
              {when && <span className="font-normal opacity-90"> (laatste fout: {when})</span>}
            </p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={() => navigate('/?tab=settings&section=whatsapp')}
              className="text-xs bg-white/20 hover:bg-white/30 px-2.5 py-1 rounded transition-colors font-medium flex items-center gap-1"
            >
              <MessageSquare className="h-3.5 w-3.5" />
              Token vernieuwen
            </button>
            <button
              onClick={() => refetch()}
              disabled={isFetching}
              className="p-1 hover:bg-white/20 rounded transition-colors"
              aria-label="Opnieuw checken"
            >
              <RefreshCw className={`h-3.5 w-3.5 ${isFetching ? 'animate-spin' : ''}`} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
